import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import posed, { PoseGroup } from 'react-pose';
import Layout from './Layout';
import UserList from '../components/user/List';
import UserRegister from '../components/user/Register';
import UserProfile from '../components/user/Profile';
import UserDelete from '../components/user/Delete';
import UserPassword from '../components/user/Password';
import CouponList from '../components/coupon/List';
import PublicationList from '../components/publication/List';
import PublicationEdit from '../components/publication/Edit';
import BranchList from '../components/branch/List';
import BranchEdit from '../components/branch/Edit';
import CouponCampaignList from '../components/couponCampaign/List';
import CouponCampaignEdit from '../components/couponCampaign/Edit';
import EmailList from '../components/email/List';
import EmailEdit from '../components/email/Edit';
import UserLogin from '../components/user/Login';
import Background from './Background';
import Notification from './Notification';
import { selectors } from '../store/modules/User';

const App = (props) => {
  const { isAuthenticated, isAdmin, location } = props;

  const RouteContainer = posed.div({
    enter: { opacity: 1, delay: 300, beforeChildren: true },
    exit: { opacity: 0 },
  });

  return (
    <React.Fragment>
      <Layout>
        <PoseGroup key="router-pose-group">
          <RouteContainer key={`route-container-${location.pathname}`}>
            <Switch location={location}>
              {/* <Route exact path="/"
                component={Home} /> */}
              {!isAuthenticated && (
              <Route exact path="/login"
                component={UserLogin} />
              )}
              {!isAuthenticated && (
              <Route exact path="/password"
                component={UserPassword} />
              )}
              {!isAuthenticated && (
              <Route exact path="/register"
                component={UserRegister} />
              )}
              {isAuthenticated && !isAdmin && (
              <Route exact path="/profile"
                component={UserProfile} />
              )}
              {isAuthenticated && isAdmin && (
              <Route exact path="/user/:id/profile"
                component={UserProfile} />
              )}
              {isAuthenticated && !isAdmin && (
              <Route exact path="/coupon"
                component={CouponList} />
              )}
              {isAuthenticated && isAdmin && (
              <Route exact path="/user/:id/coupon"
                component={CouponList} />
              )}
              {isAuthenticated && !isAdmin && (
              <Route exact path="/user/password"
                component={UserPassword} />
              )}
              {isAuthenticated && isAdmin && (
              <Route exact path="/user"
                component={UserList} />
              )}
              {isAuthenticated && !isAdmin && (
              <Route exact path="/user/delete"
                component={UserDelete} />
              )}
              {isAuthenticated && isAdmin && (
              <Route exact path="/publication"
                component={PublicationList} />
              )}
              {isAuthenticated && isAdmin && (
              <Route exact path="/publication/:id"
                component={PublicationEdit} />
              )}
              {isAuthenticated && isAdmin && (
              <Route exact path="/branch"
                component={BranchList} />
              )}
              {isAuthenticated && isAdmin && (
              <Route exact path="/branch/:id"
                component={BranchEdit} />
              )}
              {isAuthenticated && isAdmin && (
              <Route exact path="/coupon-campaign"
                component={CouponCampaignList} />
              )}
              {isAuthenticated && isAdmin && (
              <Route exact path="/coupon-campaign/:id"
                component={CouponCampaignEdit} />
              )}
              {isAuthenticated && isAdmin && (
              <Route exact path="/email"
                component={EmailList} />
              )}
              {isAuthenticated && isAdmin && (
              <Route exact path="/email/:id"
                component={EmailEdit} />
              )}
              {/* <Route path="*" component={Home} /> */}
              {!isAuthenticated && <Redirect from="/" to="/login" />}
              {isAuthenticated && isAdmin && <Redirect from="/" to="/publication" />}
              {isAuthenticated && !isAdmin && <Redirect from="/" to="/profile" />}
            </Switch>
          </RouteContainer>
        </PoseGroup>
      </Layout>
      <Background />
      <Notification />
    </React.Fragment>
  );
};

App.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool,
  location: PropTypes.shape({ key: PropTypes.string }).isRequired,
};

App.defaultProps = {
  isAdmin: false,
};

export default connect(state => ({
  isAuthenticated: selectors.getIsAuthenticated(state),
  isAdmin: selectors.getIsAdmin(state),
  location: state.router.location,
}))(App);



// WEBPACK FOOTER //
// ./src/containers/App.jsx